// extracted by mini-css-extract-plugin
export default {"wrapper":"AddAlbum_wrapper__myUVi","main":"AddAlbum_main__L7q0L","input":"AddAlbum_input__5dcRq"};